<template>
    <div class="calendar">
        <div class="calendar-image">
            <div class="table-head">
                <div class="table-title"><span style="font-weight: bold">图片数据</span></div>
                <div class="upload-head">
                    <Select v-model="classify" style="width: 120px" placeholder="请选择类型">
                        <Option v-for="item in classifyList" :value="item.value" :key="item.value">{{
                            item.label }}
                        </Option>
                    </Select>
                    <Upload action="" :before-upload="addImgRecord" :multiple="true">
                        <Button icon="ios-cloud-upload-outline">上传图片</Button>
                    </Upload>
                </div>
            </div>
            <Table :columns="imgColumns" :data="imgData">
                <template slot-scope="{ row, index }" slot="id">
                    <span>{{ row.id }}</span>
                </template>

                <template slot-scope="{ row, index }" slot="url">
                    <Poptip trigger="hover" :transfer="true" title="图片详情">
                        <div class="info-pop" slot="content">
                            <img :src="row.show_url">
                        </div>
                        <img :src="row.url" style="width: 50px;height: 50px;">
                    </Poptip>
                </template>

                <template slot-scope="{ row, index }" slot="classify">
                    <span>{{ row.classify }}</span>
                </template>

                <!--                <template slot-scope="{ row, index }" slot="action">-->
                <!--                    <div>-->
                <!--                        <Button @click="deleteImgRecord(row, index)">删除</Button>-->
                <!--                    </div>-->
                <!--                </template>-->
            </Table>
        </div>
    </div>
</template>

<script>
    import apis from "../../http/api";
    import OSS from 'ali-oss';
    import {tryHideFullScreenLoading} from "../../http/http";

    export default {
        name: "calendar",
        data() {
            return {
                ossClient: null,
                classifyList: [],
                classify: null,
                imgData: [],
                imgColumns: [
                    {
                        title: 'id',
                        slot: 'id',
                    },
                    {
                        title: '图片',
                        slot: 'url',
                        width: '',
                    },
                    {
                        title: '类型',
                        slot: 'classify',
                    },
                    // {
                    //     title: '操作',
                    //     slot: 'action',
                    //     width: 180
                    // }
                ]
            }
        },
        async created() {
            this.getClassify();
            this.getOss();
            this.getImgRecords()
        },
        methods: {
            async getOss() {
                apis.get_oss().then(res => {
                    this.ossClient = new OSS({
                        region: 'oss-cn-shanghai',
                        accessKeyId: res.AccessKeyId,
                        accessKeySecret: res.AccessKeySecret,
                        stsToken: res.SecurityToken,
                        bucket: 'co-study',
                    })
                }).catch(err => {
                    console.log(err)
                })
            },
            async addImgRecord(event) {
                try {
                    let ts = (new Date()).valueOf();
                    let filename = '.' + event.name.split('.').pop();
                    if(filename !== '.png'){
                        this.$Message.error('仅支持上传png格式的图片');
                        return Promise.reject()
                    }
                    let oss_url = 'calendar/' + this.classify + ts.toString() + filename;
                    // let oss_url = 'calendar_test/' + this.classify + ts.toString() + filename;
                    let name = 'app/image/share/' + oss_url;
                    if (this.classify === null) {
                        this.$Message.error('请先选择类型');
                        return Promise.reject()
                    }
                    let result = await this.ossClient.put(name, event);
                    if (result.res.status === 200) {
                        let post_data = {
                            url: oss_url,
                            classify: this.classify
                        };
                        apis.calendar_add_img_record(post_data).then(res => {
                            const {data, errCode, msg} = res;
                            if (errCode === 0) {
                                this.$Message.success('上传成功');
                                this.getImgRecords()
                            }
                        })
                    } else {
                        console.log(result)
                        this.$Message.error('上传至oss失败');
                    }
                } catch (e) {
                    console.log(e);
                    this.$Message.error('上传至oss失败');
                }
                return Promise.reject()
            },
            async getClassify() {
                await apis.calendar_get_img_classify().then(res => {
                    const {data, errCode, msg} = res;
                    if (errCode === 0) {
                        this.classifyList = data.records
                    }
                })
            },
            async getImgRecords() {
                await apis.calendar_get_img_records().then(res => {
                    const {data, errCode, msg} = res;
                    if (errCode === 0) {
                        this.imgData = data.records
                    }
                })
            },
            async deleteImgRecord(row) {
                let post_data = {
                    id: row.id,
                }
                await apis.calendar_delete_img_record(post_data).then(res => {
                    const {data, errCode, msg} = res;
                    if (errCode === 0) {

                    }
                }).catch()
                await this.getImgRecords()

            },
        }
        ,
        computed: {}
    }
</script>

<style scoped>
    .calendar {
        margin: 10px;
    }

    .table-head {
        display: flex;
        justify-content: space-between;
        padding-bottom: 5px;
    }

    .table-title {
        align-self: center;
    }

    .upload-head {
        display: flex;
    }


</style>